import React, { FC } from 'react';
import styled        from 'styled-components';

const Wrapper = styled.div`
  display : flex;
  padding : 10px 0;
`;

export const LinksWrapper: FC = ({ children }) => (
  <Wrapper>
    {children}
  </Wrapper>
);
